export const FeedbackConstants = {
    GET_FEEDBACK_REQUEST: 'GET_FEEDBACK_REQUEST',
    GET_FEEDBACK_SUCCESS: 'GET_FEEDBACK_SUCCESS',
    GET_FEEDBACK_FAILURE: 'GET_FEEDBACK_FAILURE',
}